// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"cda0c9ce","268":"af8dc860","457":"928c96fe","551":"3eb00141","842":"ba9a9e53","950":"cac46121","980":"45dd80fc"}[chunkId] + ".chunk.js";
};